import axios from 'axios'

// Public-Read-API (Spec Abschnitt 6.1): ohne Token, eigener Rate-Limit-Topf.
// Die Basis-URL liefert WordPress über wp_localize_script als matrixPublicParams.
const base = () => matrixPublicParams.api_url

const get = async (path) => (await axios.get(`${base()}/public${path}`)).data

export const loadEvents = () => get('/events')
export const loadEvent = (slug) => get(`/events/${slug}`)
export const loadExhibitors = (slug) => get(`/events/${slug}/exhibitors`)
export const loadJobs = (params = '') => get(`/jobs${params}`)
export const loadJob = (slug) => get(`/jobs/${slug}`)
// Vereinsmitglieder fuer das Logo-Raster der Mitgliederseite (#242).
export const loadMembers = () => get('/members')
// Aussteller-Profilseite (#239).
export const loadExhibitor = (id) => get(`/exhibitors/${encodeURIComponent(id)}`)

// Seitenliste aus WordPress (#60, #201): eigene Basis-URL, nicht die Matrix-API.
export const loadWpPages = async () =>
    (await axios.get(`${matrixPublicParams.wp_rest_url}/event-pages`)).data
